import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";

const styles = {
    base: {
        width: "234px",
        paddingLeft: "8px",
        flexShrink: 0,
    },
    divider: {
        height: "1px",
        backgroundColor: theme.palette.lightGrey,
        margin: "0 16px 12px",
    },
};

class Sidebar extends PureComponent {
    static propTypes = {
        children: PropTypes.node,
        hideDividers: PropTypes.bool,
    };

    static defaultProps = {
        hideDividers: true,
    };

    render() {
        const { children, hideDividers } = this.props;

        const newChildren = [];
        React.Children.forEach(
            children,
            (currentChild, i) => {
                if (!hideDividers) {
                    newChildren.push(<div key={`divider-${i}`} style={styles.divider} />);
                }
                newChildren.push(currentChild);
            },
            this
        );

        return <aside style={styles.base}>{newChildren}</aside>;
    }
}

export default Sidebar;
